import { render, staticRenderFns } from "./ReleaseDetailView.vue?vue&type=template&id=19030ff7&scoped=true"
import script from "./ReleaseDetailView.vue?vue&type=script&lang=js"
export * from "./ReleaseDetailView.vue?vue&type=script&lang=js"
import style0 from "./ReleaseDetailView.vue?vue&type=style&index=0&id=19030ff7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19030ff7",
  null
  
)

export default component.exports